<template>
  <div
    class="pb-4 lg:!grid lg:!grid-cols-3"
    :class="{ 'lg:!-mx-4': width === 'full' }"
  >
    <div
      :class="[
        'col-span-3',
        'w-full !py-0 lg:!flex lg:!flex-col',
        width === 'auto' ? 'min-w-72' : '',
      ]"
    >
      <slot name="one" />
    </div>
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: "ColOne"
})

defineProps({
  proportion: { type: String, default: '100' },
  width: { type: String, default: 'full' }
})
</script>
